export const hasMinimumLength = minimumLength => value =>
  value.length >= minimumLength;

export const hasMinimumAlphaCharacters = numberOfAlphaCharacters => value =>
  value.replace(/\d/g, '').length >= numberOfAlphaCharacters;

export const hasMinimumNumericCharacters = numberOfNumericCharacters => value =>
  value.replace(/\D/g, '').length >= numberOfNumericCharacters;

export const hasMinimumUppercaseLetters = numberOfUppercaseCharacters => value =>
  value.replace(/[^A-Z]/g, '').length >= numberOfUppercaseCharacters;

export const hasMinimumLowercaseLetters = numberOfLowercaseCharacters => value =>
  value.replace(/[^a-z]/g, '').length >= numberOfLowercaseCharacters;

export const hasMinimumSpecialCharacters = numberOfSpecialCharacters => value =>
  value.replace(/[a-zA-Z0-9]/g, '').length >= numberOfSpecialCharacters;

export const doesNotStartOrEndWithSpaceCharacter = value =>
  value.length > 0 && !(value.startsWith(' ') || value.endsWith(' '));

export const doesNotContainSpaceCharacter = value =>
  value.length > 0 && value.indexOf(' ') === -1;
